var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rx-app-container"},[_c('HanderNav',{attrs:{"title":"融星贷"}}),_c('ApplicationResult',{attrs:{"isSuccess":_vm.isSuccess,"items":_vm.products},on:{"select":_vm.onSelectProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }